import React, { useState } from 'react';
import { useEditor } from '../contexts/EditorContext';
import { useLanguage } from '../i18n';
import { TextElement } from '../types/elements';

const AddTextElement: React.FC = () => {
  const { addElement, elements } = useEditor();
  const { t } = useLanguage();
  const [text, setText] = useState(t('components.addText.defaultText'));
  const [fontSize, setFontSize] = useState(32);
  const [color, setColor] = useState('#000000');

  const getNextName = () => {
    let idx = 1;
    const base = 'text-';
    while (elements.some(e => e.name === base + idx)) idx++;
    return base + idx;
  };
  const [name, setName] = useState(getNextName());

  const handleAdd = () => {
    // يضمن أن الـ name يبدأ بـ text-
    let finalName = name.replace(/[^a-zA-Z0-9\-_]/g, '');
    if (!finalName.startsWith('text-')) {
      finalName = 'text-' + finalName.replace('text-', '');
    }
    if (!finalName || finalName === 'text-') finalName = getNextName();
    const id = Date.now().toString();
    const order = elements.length;
    let lastFont = 'Cairo, sans-serif';
    try {
      const saved = localStorage.getItem('editor-last-font-family');
      if (saved) lastFont = saved;
    } catch {}
    const newText: TextElement = {
      id,
      type: 'text',
      order,
      x: 50,
      y: 50 + order * 40,
      text,
      fontSize,
      color,
      name: finalName,
      width: 300,
      height: 80,
      fontFamily: lastFont, // استخدم آخر خط مختار
      fontWeight: '400',
      textAlign: 'right',
      direction: 'rtl',
      autoFitFont: true, // تفعيل التصغير التلقائي للخط
    };
    addElement(newText);
    setName(getNextName());
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <h3 style={{ color: '#fff', marginBottom: 12, fontSize: 18 }}>{t('components.addText.title')}</h3>
      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input value={text} onChange={e => setText(e.target.value)} style={{ flex: 1, background: 'rgba(0, 0, 0, 0.3)', color: '#fff', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 8, padding: '8px' }} placeholder={t('components.addText.textPlaceholder')} />
        <input type="number" value={fontSize} min={8} max={200} onChange={e => setFontSize(Number(e.target.value))} style={{ width: 70, background: 'rgba(0, 0, 0, 0.3)', color: '#fff', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 8, padding: '8px' }} />
        <input type="color" value={color} onChange={e => setColor(e.target.value)} style={{ width: 50, background: 'transparent', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 8, cursor: 'pointer' }} />
      </div>
      <div style={{ marginBottom: 12 }}>
        <label style={{ display: 'block', marginBottom: 4, fontSize: 12, color: '#a1a1aa' }}>{t('components.addText.elementNameLabel')}</label>
        <input value={name} onChange={e => setName(e.target.value.replace(/[^a-zA-Z0-9\-_]/g, ''))} style={{ width: '100%', background: 'rgba(0, 0, 0, 0.3)', color: '#fff', border: '1px solid rgba(255, 255, 255, 0.1)', borderRadius: 8, padding: '8px' }} placeholder="name1" required />
      </div>
      <button onClick={handleAdd} style={{ width: '100%', background: '#1e48e0', color: '#fff', border: 'none', borderRadius: 8, padding: '10px', fontWeight: 700, cursor: 'pointer', transition: 'background 0.2s' }} onMouseEnter={e => e.currentTarget.style.background = '#163aa8'} onMouseLeave={e => e.currentTarget.style.background = '#1e48e0'}>{t('components.addText.addButton')}</button>
    </div>
  );
};

export default AddTextElement;
